import * as React from "react";
import { connect } from "react-redux";
import { getUser } from "src/login/selector";
import { State } from "src/state";
import { getTagAreas } from "./selector";

import { TagArea } from "./types";

interface TagHighlightProps {
  tagAreas: TagArea[];
  pageNumber: number;
  userId: string;
}

const TagHighlight = (props: TagHighlightProps) => {
  const { tagAreas, pageNumber } = props;

  return (
    <React.Fragment>
      {tagAreas.map(area => {
        const left = area.left;
        const top = area.top;
        const width = area.width;
        const height = area.height;
        const style: React.CSSProperties = {
          position: "absolute",
          left: `calc(${left}% - 8px)`,
          top: `calc(${top}% - 2px)`,
          width: `calc(${width}% + 16px)`,
          height: "0px",
          // use padding to simulate height
          paddingBottom: `${height}%`,
          border: "2px solid #4B0082",
          backgroundColor: "rgba(75, 0, 130, 0.5)"
        };

        return area.pageNumber === pageNumber ? (
          <div key={Math.random()} style={style} />
        ) : null;
      })}
    </React.Fragment>
  );
};

const mapStateToProps = (state: State) => ({
  userId: getUser(state).userId,
  tagAreas: getTagAreas(state)
});

export default connect(
  mapStateToProps,
  {}
)(TagHighlight);



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/Tag/TagHighlight.tsx